const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const Link = require("../core/view/Link");

const styles = require("./styles/HoverButton.css");

/*
  Using css :hover is not reliable way of emulating touch events across all mobile devices.
  In particular, :hover can become active even without any mouse/touch events firing.
  This can happen if the button overlaps with other elements that can also receive touch events (noticed with dropdown selectors).
  Calling evt.stopPropagation() and evt.preventDefault() was not enough to prevent mobile browsers from erroneously simulating hover effects.
*/

module.exports = createReactClass({
	displayName: "HoverButton",

	propTypes: {
		text: PT.string.isRequired,
		additionalClass: PT.string,
		tabIndex: PT.number,
		onClick: PT.func,
		linkTo: PT.string,
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	setHover: function(isHovering) {
		this.setState({isHovering: isHovering});
	},

	blurButton: function() {
		this.button.blur();
	},

	onButtonClick: function() {
		this.blurButton();
		this.props.onClick && this.props.onClick();
	},

	render: function() {
		const {text, linkTo, tabIndex, additionalClass} = this.props;
		const onButtonEnter = evt => {
			if (evt.which === 13) {
				this.onButtonClick();
			}
		};

		let mainClass = styles.main;
		if (this.state.isHovering) mainClass += " " + styles.mainHover;
		if (additionalClass) mainClass += " " + additionalClass;

		let contents = text;
		if (linkTo) {
			contents = (
				<Link to={linkTo} className={styles.innerLink}>
					{text}
				</Link>
			);
		}

		return (
			<div
				className={mainClass}
				ref={b => (this.button = b)}
				onContextMenu={this.blurButton}
				tabIndex={tabIndex}
				onClick={this.onButtonClick}
				onMouseEnter={evt => this.setHover(true)}
				onMouseLeave={evt => this.setHover(false)}
				onTouchStart={evt => this.setHover(true)}
				onTouchEnd={evt => this.setHover(false)}
				onTouchCancel={evt => this.setHover(false)}
				onKeyPress={onButtonEnter}
			>
				{contents}
			</div>
		);
	},
});
